<template>
  <div
    class="submissions-app"
    :class="{ open: showFilter, closed: !showFilter }"
  >
    <div class="facets-title">
      <h1>Submissions</h1>
    </div>
    <div
      ref="sidebar-facets"
      class="sidebar-left"
      :class="{ open: showFilter, closed: !showFilter }"
    >
      <div class="facets-title">
        <h1>Submissions</h1>
      </div>
      <div class="facets-data">
        <div class="search-bar">
          <md-field class="search">
            <label>Search here</label>
            <md-icon>search</md-icon>
            <md-input
              @keyup="searchBarTyping = true"
              @keyup.enter="
                searchBarTyping = false;
                goSearch();
              "
              v-model="searchBar"
            ></md-input>
            <md-button
              v-show="searchBarTyping == true"
              @click="
                searchBarTyping = searchBar == '' ? true : false;
                goSearch();
              "
              class="md-button search"
            >
              Search
              <md-icon>arrow_right_alt</md-icon>
            </md-button>
            <md-button
              v-show="searchBarTyping == false"
              @click="
                searchBarTyping = true;
                searchBar = '';
                goSearch();
              "
              class="md-icon-button clear"
            >
              <md-icon class="clear">close</md-icon>
            </md-button>
          </md-field>
          <md-button @click="toogleSidebar()" class="filter">
            <md-icon>filter_list</md-icon>
            <span>Filter</span>
            <md-icon class="close" :class="{ active: showFilter }"
              >close</md-icon
            >
          </md-button>
        </div>
        <div
          class="other-filters"
          :class="{ open: showFilter, closed: !showFilter }"
        >
          <div class="filters">
            <div
              class="data"
              :key="index"
              v-for="(facet, index) in facets_ordered"
            >
              <div
                class="facet-wrapper"
                :key="field"
                v-for="(item, field) in facet"
                :class="{ collapsed: collapsed[field] }"
              >
                <a @click="toggleFilterItem(field)">
                  <span v-if="field=='school'">Group</span>
                  <span v-else>{{ field }}</span>
                  <md-icon>{{
                    collapsed[field] ? "expand_less" : "expand_more"
                  }}</md-icon>
                </a>
                <div class="facet" :class="field" v-show="collapsed[field]">
                  <md-checkbox
                    :ref="field + '_' + index"
                    :key="index"
                    v-for="(data, index) in item"
                    @change="updateData(data.url)"
                    v-model="data.values.active"
                    :value="data.values.value"
                    >{{ transformValue(field, data.values.value) }}</md-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <md-button class="clear" v-on:click="clearSearchResult"
              >Reset</md-button
            >
            <md-button class="md-raised apply" v-on:click="applySearch"
              >Apply</md-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="results_count">
      <div class="count">
        {{ result_count }} Result{{ result_count > 1 ? "s" : "" }}
      </div>
      <div class="breadcrumbs">
        <div :key="index" v-for="(facet, index) in facets">
          <div
            class="breadcrumbs-group"
            :key="field"
            v-for="(item, field) in facet"
          >
            <div :key="index" v-for="(data, index) in item">
              <div v-if="data.values.active" class="breadcrumb">
                <span>{{ transformValue(field, data.values.value) }}</span>
                <md-button
                  class="md-icon-button"
                  @click="removeFacetsAction(data)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </div>
        <md-button
          v-if="breadcrumbs.length"
          class="clear"
          v-on:click="clearSearchResult"
          >Clear all</md-button
        >
      </div>
    </div>
    <div class="result">
      <md-table v-if="filtered" md-card>
        <md-table-row>
          <md-table-head v-for="(name, key) in columns" :class="key" :key="key">
            <span v-if="key == 'id'">{{ name }}</span>
            <a v-else @click="toggleSort(key)" :class="{ active: sorted[key] }">
              {{ name }}
              <md-icon>{{
                sorted[key] === "ASC" ? "expand_less" : "expand_more"
              }}</md-icon>
            </a>
          </md-table-head>
        </md-table-row>
        <md-table-row :key="i" v-for="(item, i) in filtered">
          <md-table-cell :key="key" v-for="(name, key) in columns" :class="key">
            <span v-if="key === 'learner'" v-html="item.learner"></span>
            <span v-else-if="key === 'form'">{{
              transformValue("form", item.form)
            }}</span>
            <span v-else-if="key === 'id'">
              <a :href="'/activity-submission/' + item.id" target="_blank"
                >View</a
              >
            </span>
            <span v-else v-html="item[key]"></span>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <div class="pagination">
        <pagination
          v-model="currentPage"
          :records="+pager.total_items"
          :per-page="+pager.items_per_page"
          :options="{ chunk: 7, chunksNavigation: true, edgeNavigation: true }"
          @paginate="pagerAction"
        ></pagination>
      </div>
    </div>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import Spinner from "./components/Spinner.vue";

export default {
  name: "Submissions",
  mounted() {
    this.fetchInitialData();
  },

  computed: {
    breadcrumbs() {
      let breadcrumbs = [];
      for (let facet in this.facets) {
        if (!this.facets[facet]) {
          continue;
        }
        let keys = Object.keys(this.facets[facet]);
        let key = keys && keys[0] ? keys[0] : null;
        if (!key) {
          continue;
        }
        for (let index in this.facets[facet][key]) {
          if (this.facets[facet][key][index].values.active) {
            let el = {
              value: this.facets[facet][key][index].values.active,
              url: this.facets[facet][key][index].url,
            };
            breadcrumbs.push(el);
          }
        }
      }
      return breadcrumbs;
    },
    result_count() {
      return this.pager && this.pager.total_items ? this.pager.total_items : 0;
    },
    facets_ordered() {
      var ordering = {}, // map for efficient lookup of sortIndex
        sortOrder = ["school", "role", "competency", "strategy", "form"];
      for (var i = 0; i < sortOrder.length; i++) {
        ordering[sortOrder[i]] = i;
      }
      return this.facets.sort((a, b) => {
        return (
          ordering[Object.keys(a)[0]] - ordering[Object.keys(b)[0]] ||
          Object.keys(a)[0].localeCompare(Object.keys(b)[0])
        );
      });
    },
  },
  components: {
    Spinner,
  },
  data() {
    let cols = window.drupalSettings.controller.submissions_settings.columns;
    let sorted = {};
    let keys = Object.keys(cols);
    for (let i = 0; i < keys.length; i++) {
      sorted[keys[i]] = 0;
    }
    return {
      collapsed: {},
      lastUrl: "/rest/activity-submissions?_format=json",
      facets: [],
      activeFacets: {},
      pager: [],
      currentPage: 1,
      searchBar: "",
      searchBarTyping: true,
      filtered: [],
      columns: cols,
      sorted: sorted,
      showLoader: false,
      showFilter: false,
      small: false,
    };
  },
  watch: {
    facets: function (val) {
      val.map((el) => {
        if (el) {
          let key = Object.keys(el)[0];
          if (this.collapsed[key] === undefined) {
            this.collapsed[key] = false;
          }
        }
      });
      this.collapsed = Object.assign({}, this.collapsed);
    },
  },
  methods: {
    toggleSort(column) {
      let direction;
      let keys = Object.keys(this.sorted);
      for (let i = 0; i < keys.length; i++) {
        if (keys[i] == column) {
          direction = "DESC";
          if (this.sorted[column]) {
            direction = this.sorted[column] === "DESC" ? "ASC" : "DESC";
          }
          this.sorted[keys[i]] = direction;
        } else {
          this.sorted[keys[i]] = 0;
        }
      }
      let url = this.updateUrl({
        sort_by: column,
        sort_order: direction.toUpperCase(),
      });
      this.updateData(url);
    },

    toggleFilterItem(i) {
      this.collapsed[i] = !this.collapsed[i];
      if (this.$mq == "large" || this.$mq == "xlarge") {
        for (let key in this.collapsed) {
          if (key != i) {
            this.collapsed[key] = 0;
          }
        }
      }
    },
    toogleSidebar(force) {
      if (force !== undefined) {
        this.showFilter = force;
      } else {
        this.showFilter = !this.showFilter;
      }
      for (let key in this.collapsed) {
        this.collapsed[key] = 0;
      }
    },
    getFacetsSettings() {
      return window.drupalSettings.controller.submissions_settings.facets;
    },
    getAllUrlParams(url) {
      // get query string from url (optional) or window
      var queryString = url
        ? url.split("?")[1]
        : window.location.search.slice(1);

      // we'll store the parameters here
      var obj = {};

      // if query string exists
      if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split("#")[0];

        // split our query string into its component parts
        var arr = queryString.split("&");

        for (var i = 0; i < arr.length; i++) {
          // separate the keys and the values
          var a = arr[i].split("=");

          // set parameter name and value (use 'true' if empty)
          var paramName = a[0] ? a[0] : "";
          var paramValue = typeof a[1] === "undefined" ? true : a[1];

          // (optional) keep case consistent
          paramName = paramName.toLowerCase();
          //if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

          // if the paramName ends with square brackets, e.g. colors[] or colors[2]
          if (paramName.match(/\[(\d+)?\]$/)) {
            // create key if it doesn't exist
            var key = paramName.replace(/\[(\d+)?\]/, "");
            if (!obj[key]) obj[key] = [];

            // if it's an indexed array e.g. colors[2]
            if (paramName.match(/\[\d+\]$/)) {
              // get the index value and add the entry at the appropriate position
              var index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
            } else {
              // otherwise add the value to the end of the array
              obj[key].push(paramValue);
            }
          } else {
            // we're dealing with a string
            if (!obj[paramName]) {
              // if it doesn't exist, create property
              obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === "string") {
              // if property does exist and it's a string, convert it to an array
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
            } else {
              // otherwise add the property
              obj[paramName].push(paramValue);
            }
          }
        }
      }

      return obj;
    },
    decorateFacets(facets) {
      let result = [];
      let facetsSettings = this.getFacetsSettings();
      let enabledFacets = [];
      let existingFacets = [];

      for (let facet in facets) {
        for (let item in facets[facet]) {
          if (!facets[facet][item].hasOwnProperty("#type")) {
            Object.keys(facets[facet][item]).forEach((key) => {
              facets[facet][item][key].forEach((value, index) => {
                if (
                  facets[facet][item][key][index].values.active &&
                  facets[facet][item][key][index].values.active == "true"
                ) {
                  let val = facets[facet][item][key][index].values.value;
                  facets[facet][item][key][index].values.active = val;
                  this.activeFacets[val] = key;
                }
              });
            });
            Object.keys(facets[facet][item]).forEach((key) => {
              facets[facet][item][key].sort((a, b) => {
                if (a.values.value > b.values.value) {
                  return 1;
                }
                if (a.values.value < b.values.value) {
                  return -1;
                }
                return 0;
              });
            });
            existingFacets.push(facets[facet][item]);
          }
        }
      }
      for (let i in facetsSettings) {
        if (!(facetsSettings[i] == 0)) {
          enabledFacets.push(facetsSettings[i]);
        }
      }
      for (let i in enabledFacets) {
        existingFacets.filter((item) => {
          if (item.hasOwnProperty(enabledFacets[i])) {
            result.push(item);
          }
        });
      }
      return result;
    },
    removeFacetsAction(removedFacet) {
      this.updateData(removedFacet.url);
    },
    applySearch() {
      this.searchBarTyping = this.searchBar == "" ? true : false;
      this.goSearch();
      this.toogleSidebar(0);
    },
    goSearch() {
      let phrase = this.searchBar.toLowerCase().trim();
      if (phrase || (!phrase && this.lastUrl.indexOf("&search=") !== -1)) {
        let url = this.updateUrl({ search: phrase });
        this.updateData(url);
      } else {
        let url = this.updateUrl({});
        this.updateData(url);
      }
    },
    clearSearchResult() {
      this.searchBar = "";
      this.searchBarTyping = true;
      this.fetchInitialData();
      this.toogleSidebar(0);
    },
    fetchInitialData() {
      this.showLoader = true;
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };
      fetch("/rest/activity-submissions?_format=json", options)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.filtered = data.search_results;
          this.pager = data.pager;
          this.facets = this.decorateFacets(data.facets);
          this.showLoader = false;
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
    updateData(url) {
      this.showLoader = true;
      this.lastUrl = url;
      fetch(url)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.filtered = data.search_results;
          this.pager = data.pager;
          this.facets = this.decorateFacets(data.facets);
          this.showLoader = false;
          this.currentPage = this.pager.current_page + 1;
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
    pagerAction(page) {
      if (page) {
        this.currentPage = page;
        let restPage = +page - 1;
        let url = this.updateUrl({ page: restPage });
        this.updateData(url);
      }
    },

    transformValue(field, val) {
      if (field === "form") {
        switch (val) {
          case "activity_form":
            return "Activity";
          case "field_set_form":
            return "Set";
          case "field_go_form":
            return "Go";
        }
      }
      return val;
    },

    updateUrl(queryParams) {
      let params = this.getAllUrlParams(this.lastUrl);
      let newParams = Object.keys(queryParams);
      for (let i = 0; i < newParams.length; i++) {
        let parameter = newParams[i];
        params[parameter] = queryParams[parameter];
      }
      return this.getUrlByParams(params);
    },

    getUrlByParams(params) {
      let arr = [];
      for (let [k, v] of Object.entries(params)) {
        if (v) {
          // Sort order must be uppercase
          if (k === "sort_order") {
            v = v.toUpperCase();
          }
          arr.push(k + "=" + v);
        }
      }
      return "/rest/activity-submissions?" + arr.join("&");
    },
  },
};
</script>

<style lang="scss">
.downscroll {
  .submissions-app {
    .sidebar-left {
      transform: translate3d(0, 0, 0);
      &::before {
        background-position: bottom -300px right -10px;
      }
      &.open {
        .search-bar {
          max-height: 56px;
          opacity: 1;
        }
      }
      &.closed {
        h1 {
          text-align: center;
          font-size: 16px;
          margin: -10px 0px 10px;
          font-weight: normal;
        }
      }
    }
    .search-bar {
      //max-height: 0;
      // opacity: 0;
      &.closed {
        max-height: 56px;
      }
      &.open {
        max-height: 56px;
      }
    }
  }
}
.upscroll {
  .submissions-app {
    .search-bar {
      max-height: 56px;
    }
  }
}
.submissions-app {
  .facets-title h1 {
    font-size: 36px;
    line-height: 54px;
    color: $title-blue;
    margin: 0;
  }
  .results_count {
    @media all and (max-width: $breakpoint-medium) {
      //padding-top: 120px;
    }
    .count {
      color: $blue-dark;
      float: left;
      padding-right: 24px;
      padding-top: 5px;
      text-transform: uppercase;
    }
    &:after {
      display: block;
      content: "";
      clear: both;
    }
  }
  .breadcrumbs {
    @media all and (max-width: $breakpoint-medium) {
      display: none;
    }
    display: flex;
    flex-wrap: wrap;
    .breadcrumbs-group {
      display: flex;
      flex-wrap: wrap;
    }
    .clear.md-button.md-theme-default {
      color: $blue-dark;
      margin: 0;
      height: 29px;
      font-size: 18px;
      font-weight: bold;
    }
    .breadcrumb {
      font-family: $font-filson-soft;
      text-transform: uppercase;
      margin-right: 16px;
      margin-bottom: 10px;
      display: flex;
      background: $blue-dark;
      border-radius: 15px;
      padding: 4px 16px;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: $white;
      .md-button.md-theme-default {
        margin-right: -4px;
        color: $white;
        font-size: 16px;
        .md-ripple {
          padding: 8px;
        }
        .md-icon {
          width: 16px;
          min-width: 16px;
          height: 16px;
          color: $white;
          font-size: 16px !important;
        }
        min-width: 20px;
        height: 20px;
        width: 20px;
      }
    }
  }
  @media all and (min-width: $breakpoint-medium) {
    &.open {
      &::before {
        content: "";
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 99;
      }
    }
  }
  .actions {
    padding-bottom: 32px;
    padding-top: 32px;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    display: flex;
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
    @media all and (max-width: $breakpoint-medium) {
      padding-top: 5px;
    }
    &::after {
      content: "";
      display: block;
      clear: both;
    }
    .clear {
      margin: 0 auto;
      color: rgb(255, 255, 255);
      font-size: 14px;
      font-weight: bold;
      font-family: $font-filson-soft;
    }
    .apply {
      margin: 0 auto;
      color: $white;
      &.md-theme-default.md-raised:not([disabled]) {
        font-size: 16px;
        font-family: $font-filson-soft;
        background: $white;
        color: $blue-dark;
      }
    }
  }
  .result {
    padding-top: 10px;
    .md-card {
      width: 100%;
    }
    .md-table-content {
      padding: 0;
      table {
        margin: 20px 0;
      }
      .md-table-row {
        td {
          border: none;
          font-size: 14px;
          font-family: $font-source-sans-pro;
          color: #3c3c3c;
          letter-spacing: normal;
          a {
            font-size: 14px;
            font-family: $font-source-sans-pro;
            font-weight: normal;
          }
          &.id {
            text-align: center;
            a {
              display: inline-block;
              padding: 8px 21px;
              border-radius: 20px;
              text-decoration: none;
              color: $white;
              font-size: 16px;
              font-family: $font-filson-soft;
              font-weight: bold;
              line-height: 24px;
              background-color: $blue-active;
            }
          }
        }
        border: none;
        border-top: 1px solid #e0e0e0;
      }
      .md-table-head {
        background-color: $white;
        color: #3c3c3c;
        font-size: 14px;
        font-family: $font-filson-soft;
        text-transform: uppercase;
        &.id {
          text-align: center;
        }
        .md-table-head-container {
          padding: 5px 9px 10px;
          height: auto;
          .md-table-head-label {
            padding: 0;
            a {
              cursor: pointer;
              color: #3c3c3c;
              text-decoration: none;
              .md-icon.md-theme-default.md-icon-font {
                color: var(
                  --md-theme-default-icon-on-background,
                  rgba(0, 0, 0, 0.34)
                );
              }
              &.active {
                .md-icon.md-theme-default.md-icon-font {
                  color: var(
                    --md-theme-default-icon-on-background,
                    rgba(0, 0, 0, 0.84)
                  );
                }
              }
            }
          }
        }
      }
      .md-table-cell {
        background-color: $white;
        .md-table-cell-container {
          padding: 5px 0;
        }
      }
    }
    @media all and (min-width: $breakpoint-medium) {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .VuePagination {
      margin-bottom: 20px;
      a {
        color: $white;
        &:hover {
          color: $white;
        }
        &.page-link[disabled="disabled"] {
          opacity: 0.4;
        }
      }
    }
  }
  .search-bar {
    transition: $transition;
    transition: var(--transition);
    overflow: hidden;
    display: flex;
    max-height: 56px;
    .filter {
      height: 42px;
      margin: 0px 8px;
      min-width: 50px;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: normal;
      .md-button-content {
        color: $blue-dark;
        display: flex;
        flex-direction: column;
      }
      .md-icon {
        color: $blue-dark;
        &.close {
          position: absolute;
          display: none;
          border-radius: 50%;
          bottom: 19px;
          right: 4px;
          font-size: 12px !important;
          min-width: 12px;
          width: 12px;
          height: 12px;
          background-color: #f64536;
          border-radius: 50%;
          &.active {
            display: block;
          }
        }
      }
    }
    .search {
      @media all and (min-width: $breakpoint-medium) {
        max-width: inherit;
      }
    }
  }
  .other-filters {
    overflow: hidden;
    transition: $transition;
    transition: var(--transition);
    .filters {
      max-height: calc(100vh - 200px);
      overflow-y: auto;
      overflow-x: hidden;
      @media all and (min-width: $breakpoint-medium) {
        max-height: calc(100vh - 326px);
        display: flex;
        flex-wrap: wrap;
        overflow: visible;
        .data {
          width: 33%;
          padding-right: 16px;
          break-inside: avoid-column;
        }
      }
    }
    &.closed {
      max-height: 0;
    }
    &.open {
      max-height: calc(100vh - 150px);
      @media all and (min-width: $breakpoint-medium) {
        max-height: calc(100vh - 278px);
        overflow: visible;
      }
    }
  }
  .search.md-field {
    margin: 0;
    margin-bottom: 16px;
  }

  .sidebar-left {
    transition: $transition;
    transition: var(--transition);
    overflow: hidden;
    position: fixed;
    @media all and (max-width: $breakpoint-medium) {
      top: 0;
      left: 0;
    }

    .facets-title {
      @media all and (max-width: $breakpoint-medium) {
        display: block;
      }
    }
    .md-field.search {
      .md-button.clear {
        display: none;
      }
      .md-button.search {
        @media all and (max-width: $breakpoint-medium) {
          display: none;
        }
        opacity: 1;
        border-radius: 0;
        color: $blue-dark !important;
        background-color: transparent;
        text-transform: uppercase;
        font-family: $font-filson-soft;
        font-weight: 300;
        font-size: 14px;
        &:hover {
          &::before {
            background-color: transparent;
          }
          background-color: transparent;
        }
        .md-icon {
          color: $blue-dark !important;
          display: block;
          opacity: 1;
        }
        .md-ripple {
          padding-right: 0px;
        }
      }
    }
    @media all and (min-width: $breakpoint-medium) {
      .facets-title {
        display: none;
      }
      h1 {
        font-size: 24px;
        line-height: 36px;
      }
      .facet.strategy {
        flex-basis: auto;
        margin: 0;
        max-width: 100%;
      }
      max-width: 1248px;
      width: 100%;
      overflow: visible;
      position: relative;
      // margin-left: -16px;
      // margin-right: -16px;
      .md-field.search {
        opacity: 0.7;
        &.md-focused {
          opacity: 1;
          .md-icon {
            opacity: 1;
          }
        }
        .md-icon {
          display: none;
          &.clear {
            display: block;
            color: $blue-dark !important;
            margin: 0;
          }
        }
        .md-button.clear {
          background: transparent;
          display: none;
        }
        &.md-has-value {
          .md-button.clear {
            opacity: 1;
            background: transparent;
            display: flex;
          }
        }
        label,
        input {
          padding-left: 0px;
          color: $blue-dark;
          font-size: 24px;
          font-family: $font-filson-soft;
          font-weight: normal;
          -webkit-text-fill-color: $blue-dark;
          margin: 0;
        }
        background-color: transparent;
        border-bottom: 1px solid $blue-dark;
        border-radius: 0px;
      }
      &.closed {
        z-index: 99;
        background-color: transparent;
        background-image: none;
        // padding: 20px 16px 0;
        // margin-left: -16px;
        // margin-right: -16px;
        &::before {
          background-image: none;
        }
      }
      &.open {
        position: fixed;
        z-index: 100;
        padding: 20px 16px 0;
        max-width: 1248px;
        @media all and (max-width: 1280px) {
          max-width: calc(100vw - 32px);
        }
        @media all and (max-width: 1024px) {
          max-width: calc(100vw - 16px);
        }
        width: 100%;
        .md-button.filter {
          color: $white !important;
          .md-icon {
            color: $white !important;
          }
          .md-button-content {
            color: $white;
          }
        }
        .md-field.search {
          color: $white !important;
          border-bottom-color: $white;
          .md-icon {
            color: $white !important;
          }
          input,
          label {
            color: $white !important;
            -webkit-text-fill-color: #ffffff !important;
          }
          .md-button.search {
            color: $white !important;
            .md-icon {
              color: $white !important;
            }
          }
        }
      }
      padding: 20px 0px 0;
    }
    h1 {
      margin: 0 0px 10px;
      color: #ffffff;
    }

    // margin: -3px -5%;
    padding: 47px 30px 0;
    border-radius: 0px 0px 40px 40px;
    background-color: $blue-dark;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background-image: url("./assets/book.svg");
      background-repeat: no-repeat;
      background-position: bottom -30px right -10px;
      border-radius: 40px;
    }
    width: 100%;
    z-index: 98;
    .facets-data {
      position: relative;
      &.opened {
        top: 0px;
      }
    }
  }
  .content {
    width: 100%;
  }
  .md-card {
    margin-bottom: 16px;
  }
}
.facet-wrapper {
  position: relative;
  border-radius: 20px;
  background-color: $white;
  margin-bottom: 16px;
  margin-top: 16px;
  a {
    display: block;
    text-transform: uppercase;
    cursor: pointer;
    color: rgb(60, 60, 60) !important;
    font-family: $font-filson-soft;
    font-size: 12px;
    line-height: 18px;
    padding: 10px 16px;
    .md-icon {
      float: right;
      width: 16px;
      height: 16px;
      font-size: 18px !important;
    }
    &:hover {
      text-decoration: none;
    }
  }
  &.collapsed {
    position: relative;
    width: 100%;
    z-index: 9999;
    @media all and (min-width: $breakpoint-medium) {
      position: absolute;
      width: 31%;
      border-radius: 20px 20px 20px 20px;
    }
  }
  & .facet {
    text-transform: capitalize;
    @media all and (min-width: $breakpoint-medium) {
      width: 100%;
      background-color: $white;
      border-radius: 0px 0px 20px 20px;
      z-index: 99;
      max-height: 230px;
      overflow: auto;
    }
    .md-checkbox {
      width: 100%;
    }
    &.rubric_submission_type {
      text-transform: capitalize;
    }
    &.field_education_level {
      display: flex;
      flex-wrap: wrap;
      .md-checkbox {
        margin-right: 20px;
        float: left;
        width: auto;
      }
    }
    padding: 0px 16px 16px;
    margin-top: -10px;
    .md-checkbox {
      margin: 8px 0px 0px;
      .md-checkbox-container {
        width: 12px;
        min-width: 12px;
        height: 12px;
        top: 3px;
        &:after {
          width: 6px;
          height: 8px;
          top: -1px;
          left: 1px;
        }
      }
    }
    .md-checkbox-label {
      color: rgb(60, 60, 60);
      font-family: $font-source-sans-pro;
      font-size: 14px;
      font-weight: normal;
      line-height: 21px;
      padding-left: 8px;
    }
    .md-checkbox.md-theme-default .md-checkbox-container.md-checkbox-container {
      border-color: $blue-active;
    }
    .md-checkbox.md-theme-default.md-checked.md-checked .md-checkbox-container {
      border-color: $blue-active;
      background-color: $blue-active;
    }
  }
}
</style>

